import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/buffer-recipe-calculator/pages/CalculatorPage";

export const Route = createFileRoute("/buffer-recipe-calculator")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/buffer-recipe-calculator",
      title: m.buf_meta_title(),
      description: m.buf_meta_description(),
      toolName: m.buf_tool_name(),
      faqs: [
        { q: m.buf_faq_q1(), a: m.buf_faq_a1() },
        { q: m.buf_faq_q2(), a: m.buf_faq_a2() },
        { q: m.buf_faq_q3(), a: m.buf_faq_a3() },
        { q: m.buf_faq_q4(), a: m.buf_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
